/**
 * Shared helpers for Custodian / Coordinator department activity feeds.
 */

export const ACTIVITY_ACTION_LABELS = {
  complaint_created: 'Opened',
  complaint_closed: 'Closed',
    complaint_cancelled: 'Cancelled',
    complaint_escalated: 'Escalated',
    device_added: 'Added',
};

export function getActivityDescriptionParts(act) {
  const label = ACTIVITY_ACTION_LABELS[act.activity_type] || null;
  let rest = act.description || act.activity_type || '';
  if (label && typeof rest === 'string') {
    const prefix = `${label}:`;
    if (rest.toLowerCase().startsWith(prefix.toLowerCase())) {
      rest = rest.slice(prefix.length).trim();
    }
  }
  return { label, rest };
}

export const EMPTY_DEPARTMENT_ACTIVITY_SUMMARY = {
  complaints_opened: 0,
  complaints_closed: 0,
  complaints_cancelled: 0,
  complaints_escalated: 0,
  maintenance_total: 0,
  maintenance_by_type: { ppm: 0, calibration: 0, compliance: 0 },
  unique_devices_serviced: 0,
  devices_added: 0,
  total: 0,
};

export function summarizeDepartmentActivity(recentActivity = []) {
  const stats = { ...EMPTY_DEPARTMENT_ACTIVITY_SUMMARY, maintenance_by_type: { ppm: 0, calibration: 0, compliance: 0 } };
  const servicedDevices = new Set();

  recentActivity.forEach((act) => {
    if (act.activity_type === 'complaint_created') {
      stats.complaints_opened += 1;
    } else if (act.activity_type === 'complaint_closed') {
      stats.complaints_closed += 1;
    } else if (act.activity_type === 'complaint_cancelled') {
      stats.complaints_cancelled += 1;
    } else if (act.activity_type === 'complaint_escalated') {
      stats.complaints_escalated += 1;
    } else if (act.activity_type === 'maintenance_logged') {
      stats.maintenance_total += 1;
      const mtype = act.maintenance_type?.toLowerCase();
      if (mtype && stats.maintenance_by_type[mtype] !== undefined) {
        stats.maintenance_by_type[mtype] += 1;
      }
      const deviceKey = act.device_id ?? act.device_identifier ?? act.entity_id;
      if (deviceKey) servicedDevices.add(deviceKey);
    } else if (act.activity_type === 'device_added') {
      stats.devices_added += 1;
    }
  });

  stats.unique_devices_serviced = servicedDevices.size;
  stats.total = stats.complaints_opened
    + stats.complaints_closed
    + stats.complaints_cancelled
    + stats.complaints_escalated
    + stats.maintenance_total
    + stats.devices_added;
  return stats;
}

export function resolveDepartmentActivitySummary(summary, recentActivity = []) {
  if (summary && typeof summary === 'object' && (summary.total != null || summary.maintenance_total != null)) {
    return {
      ...EMPTY_DEPARTMENT_ACTIVITY_SUMMARY,
      ...summary,
      maintenance_by_type: {
        ...EMPTY_DEPARTMENT_ACTIVITY_SUMMARY.maintenance_by_type,
        ...(summary.maintenance_by_type || {}),
      },
    };
  }
  return summarizeDepartmentActivity(recentActivity);
}
